<form name="transportForm" role="form" novalidate [formGroup]="formGroup" *ngIf="formGroup">
  <div class="row mx-2">
    <jhi-bary-input-text
      class="col-12 col-lg-6"
      [placeholder]="'MODAL_ESTIMATE.MERCHANDISE.PLACEHOLDER' | translate"
      [label]="'MODAL_ESTIMATE.MERCHANDISE.TITLE' | translate"
      [control]="getControl('description')"
    ></jhi-bary-input-text>
    <div class="col-12 col-lg-6 row mx-0">
      <jhi-bary-input-number
        class="px-0"
        keyTranslateMinError="ERROR.MIN_VAL"
        [class]="!isUnconditioned ? 'col-12 col-sm-6' : 'col-12'"
        [placeholder]="'LABEL.QUANTITY' | translate"
        [label]="'LABEL.NUMBER_OF_UNITS' | translate"
        [control]="getControl('quantity')"
      ></jhi-bary-input-number>
      <jhi-bary-input-select *ngIf="!isUnconditioned" [control]="getControl('handlingType')" [options]="handlingTypes" class="col-12 col-sm-6 px-0 pl-sm-2"></jhi-bary-input-select>
    </div>
  </div>
  <div *ngIf="isUnconditioned" class="row mx-2">
    <div class="col-12 col-lg-6 position-relative">
      <i
        class="fas fa-info-circle text-black position-absolute info-vehicle-category unconditioned"
        [mdbTooltip]="'TRANSPORT_ESTIMATION_STEP.VEHICLE_CATEGORY.TOOLTIP' | translate"
      ></i>
      <jhi-bary-input-select
        [placeholder]="'TRANSPORT_ESTIMATION_STEP.VEHICLE_CATEGORY.PLACEHOLDER' | translate"
        [label]="'LABEL.VEHICLE_CATEGORY' | translate"
        [control]="getControl('vehicleCategory')"
        [options]="categories"
      ></jhi-bary-input-select>
    </div>
    <jhi-bary-input-select
      class="col-12 col-lg-6"
      [placeholder]="'TRANSPORT_ESTIMATION_STEP.VEHICLE_TYPE.PLACEHOLDER' | translate"
      [label]="'LABEL.VEHICLE_TYPE' | translate"
      [control]="getControl('vehicleType')"
      [options]="types"
    ></jhi-bary-input-select>
    <jhi-bary-input-checkbox
      *ngIf="getControl('vehicleNotFound')"
      class="col-12"
      [label]="'TRANSPORT_ESTIMATION_STEP.VEHICLE_UNKNOWN.LABEL' | translate"
      [control]="getControl('vehicleNotFound')"
    ></jhi-bary-input-checkbox>
    <jhi-bary-input-text
      *ngIf="getControl('vehicleNotFound').value"
      class="col-12"
      [placeholder]="' '"
      [label]="'TRANSPORT_ESTIMATION_STEP.VEHICLE_OTHER_TYPE.LABEL' | translate"
      [control]="getControl('otherVehicleType')"
    ></jhi-bary-input-text>
  </div>
  <div *ngIf="!isUnconditioned" class="row mx-2">
    <div class="col-12 col-lg-6 row mx-0">
      <jhi-bary-input-number
        class="col-9 px-0"
        keyTranslateMinError="ERROR.MIN_VAL"
        [placeholder]="'LABEL.WEIGHT_BY_UNIT.PLACEHOLDER' | translate"
        [label]="'LABEL.WEIGHT_BY_UNIT' | translate"
        [control]="getControl('weight')"
      ></jhi-bary-input-number>
      <jhi-bary-input-select [control]="getControl('weightUnit')" class="col-3 pr-0 pl-2" [options]="weightUnit"></jhi-bary-input-select>
    </div>
    <div class="col-12 col-lg-6 mx-0 d-flex flex-column">
      <jhi-bary-input-select
        class="mx-0"
        *ngIf="showSelect"
        [placeholder]="getPlaceHolderKeyDimension()! | translate"
        [label]="getLabelKeyDimension()! | translate"
        [control]="getControl('dimension')"
        [options]="dimensionOpts"
      ></jhi-bary-input-select>
      <div class="px-0 text-right" *ngIf="getControl('handlingType').value === CRATE_OF_WINE">
        {{ 'WORD.BEING' | translate }}
        <span class="font-weight-bold" translate="LABEL.NUMBER_OF_BOTTLES.VALUE" [translateParams]="{ number: getControl('otherSpecificQuantity').value || '-' }"></span>
        <jhi-bary-icon icon="question-circle" [faDirective]="FAS" [title]="'TOOLTIP_MESSAGE.EQUIVALENT_NUMBER_OF_BOTTLES' | translate" class="suffix"></jhi-bary-icon>
      </div>
    </div>
  </div>
  <div class="row mx-2">
    <div class="col-12 col-lg-6 row mx-0">
      <jhi-bary-input-number
        class="col-3 px-0"
        keyTranslateMinError="ERROR.MIN_VAL"
        [placeholder]="'VEHICLE_DETAIL.FORM.LENGTH.PLACEHOLDER' | translate"
        [label]="'TRANSPORT_ESTIMATION_STEP.LENGTH.LABEL' | translate"
        [mdbTooltip]="'TRANSPORT_ESTIMATION_STEP.LENGTH.LABEL' | translate"
        [control]="getControl('length')"
      ></jhi-bary-input-number>
      <jhi-bary-input-number
        class="col-3 px-0 pl-1"
        keyTranslateMinError="ERROR.MIN_VAL"
        [placeholder]="'VEHICLE_DETAIL.FORM.WIDTH.PLACEHOLDER' | translate"
        [label]="'TRANSPORT_ESTIMATION_STEP.WIDTH.LABEL' | translate"
        [mdbTooltip]="'TRANSPORT_ESTIMATION_STEP.WIDTH.LABEL' | translate"
        [control]="getControl('width')"
      ></jhi-bary-input-number>
      <jhi-bary-input-number
        class="col-3 px-0 pl-1"
        keyTranslateMinError="ERROR.MIN_VAL"
        [placeholder]="'VEHICLE_DETAIL.FORM.HEIGHT.PLACEHOLDER' | translate"
        [label]="'TRANSPORT_ESTIMATION_STEP.HEIGHT.LABEL' | translate"
        [mdbTooltip]="'TRANSPORT_ESTIMATION_STEP.HEIGHT.LABEL' | translate"
        [control]="getControl('maxHeight')"
      ></jhi-bary-input-number>
      <jhi-bary-input-select class="col-3 pl-2 pr-0" [control]="getControl('lengthUnit')" [options]="lengthUnit"></jhi-bary-input-select>
    </div>
    <div *ngIf="isUnconditioned" class="col-12 col-lg-6 row mx-0">
      <jhi-bary-input-number
        class="col-9 px-0"
        keyTranslateMinError="ERROR.MIN_VAL"
        [placeholder]="'LABEL.WEIGHT_BY_UNIT.PLACEHOLDER' | translate"
        [label]="'LABEL.WEIGHT_BY_UNIT' | translate"
        [control]="getControl('weight')"
      ></jhi-bary-input-number>
      <jhi-bary-input-select [control]="getControl('weightUnit')" class="col-3 pr-0 pl-2" [options]="weightUnit"></jhi-bary-input-select>
    </div>
  </div>
  <div class="row mx-2" *ngIf="!isUnconditioned && isFTL">
    <div class="col-12 col-lg-6 position-relative">
      <i class="fas fa-info-circle text-black position-absolute info-vehicle-category" [mdbTooltip]="'TRANSPORT_ESTIMATION_STEP.VEHICLE_CATEGORY.TOOLTIP' | translate"></i>
      <jhi-bary-input-select
        [placeholder]="'TRANSPORT_ESTIMATION_STEP.VEHICLE_CATEGORY.PLACEHOLDER' | translate"
        [label]="'LABEL.VEHICLE_CATEGORY' | translate"
        [control]="getControl('vehicleCategory')"
        [options]="categories"
      ></jhi-bary-input-select>
    </div>
    <jhi-bary-input-select
      class="col-12 col-lg-6"
      [placeholder]="'TRANSPORT_ESTIMATION_STEP.VEHICLE_TYPE.PLACEHOLDER' | translate"
      [label]="'LABEL.VEHICLE_TYPE' | translate"
      [control]="getControl('vehicleType')"
      [options]="types"
    ></jhi-bary-input-select>
  </div>
  <div *ngIf="isUnconditioned" class="row mx-2">
    <jhi-bary-collapse [label]="'LABEL.MORES_OPTIONS' | translate" [isCollapsed]="isCollapsed" (collapseEvent)="changeCollapsed($event)" class="col-12 mt-3">
      <div class="row">
        <div class="col-12 col-lg-6 d-flex flex-row">
          <jhi-bary-input-number
            class="flex-grow-1 mr-2"
            keyTranslateMinError="ERROR.MIN_VAL"
            [label]="'VEHICLE_DETAIL.FORM.VOLUME.LABEL' | translate"
            [control]="getControl('volume')"
          ></jhi-bary-input-number>
          <jhi-bary-input-select [control]="getControl('volumeUnit')" [options]="volumeUnit" [disabled]="true"></jhi-bary-input-select>
        </div>
      </div>
    </jhi-bary-collapse>
  </div>
  <mdb-error *ngIf="formGroup.errors?.['invalidLoadingMeter']" class="mx-auto position-static text-center d-block">
    <span>{{ 'ERROR.DIMENSIONS_TOO_SMALL' | translate }}</span>
  </mdb-error>
</form>
